export const HTTP_ERROR_BAD_REQUEST = 400
export const HTTP_ERROR_NOT_FOUND = 404
export const HTTP_ERROR_UNAUTHORIZED = 401
export const HTTP_ERROR_EXPIRED_TOKEN = 403
export const HTTP_ERROR_CONFLICT = 409
export const HTTP_ERROR_INTERNAL = 500
export const HTTP_ERROR_SERVICE_UNAIVAILABLE = 503
export const HTTP_RESET_CONTENT = 205
export const HTTP_NO_CONTENT = 204
export const HTTP_OK = 200
export const HTTP_ACCEPTED = 202
export const HTTP_ERROR_NOT_ACCEPTABLE = 406

export const URL_BASE_CONFIGURATIONS = 'configurations'
export const BASE_CONFIGURATION_URL = `${URL_BASE_CONFIGURATIONS}/base/`
export const I18N_URL = 'i18n'
